import { request } from "../axios";
import { encodeQueryData, handleApiError } from "../helper";
import { KEYS } from "./keys";
import type {
  AccountOrdersResponse,
  AccountPnlHistoryResponse,
  AccountPnlSummaryResponse,
  AccountPositionsResponse,
  AccountTradesRequest,
  AccountTradesResponse,
  RemoveAccountPositionRequest,
  RemoveAccountPositionResponse,
} from "./types";

export async function getAccountPnlSummary(
  account: string,
  params: { chainId: number; debug?: boolean } | undefined
): Promise<AccountPnlSummaryResponse> {
  try {
    const query = params ? encodeQueryData(params) : "";
    const { data } = await request.get(`${KEYS.PNL_SUMMARY(account)}${query ? `?${query}` : ""}`);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function getAccountPnlHistory(
  account: string,
  params: { chainId: number; from?: number; to?: number; debug?: boolean } | undefined
): Promise<AccountPnlHistoryResponse> {
  try {
    const query = params ? encodeQueryData(params) : "";
    const { data } = await request.get(`${KEYS.PNL_HISTORY(account)}${query ? `?${query}` : ""}`);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function postAccountTrades<T = unknown>(
  account: string,
  payload: AccountTradesRequest
): Promise<AccountTradesResponse<T>> {
  try {
    const { data } = await request.post(KEYS.TRADES(account), payload);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function getAccountOrders(
  account: string,
  params: { chainId: number; debug?: boolean } | undefined
): Promise<AccountOrdersResponse> {
  try {
    const query = params ? encodeQueryData(params) : "";
    const { data } = await request.get(`${KEYS.ORDERS(account)}${query ? `?${query}` : ""}`);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function getAccountPositions(
  account: string,
  params:
    | {
        chainId: number;
        status?: "OPEN" | "CLOSED" | string;
        page?: number;
        pageSize?: number;
      }
    | undefined
): Promise<AccountPositionsResponse> {
  try {
    const query = params ? encodeQueryData(params) : "";
    const { data } = await request.get(`${KEYS.POSITIONS(account)}${query ? `?${query}` : ""}`);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function removeAccountPosition(
  account: string,
  payload: RemoveAccountPositionRequest
): Promise<RemoveAccountPositionResponse> {
  try {
    const { data } = await request.delete(KEYS.POSITIONS(account), { data: payload });
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}
